<template>
    <div class="typeahead-group">
    <div v-show="myValue.value === null">
        <b-spinner :variant="'primary'" small class="fa-spin" v-if="loading"></b-spinner>
        <!-- <i class="fa fa-spinner fa-spin" v-if="loading"></i> -->
        <input type="text" class="form-control " :placeholder="placeholder" autocomplete="off" v-model="query" @keydown.down="down" @keydown.up="up" @keydown.enter="hit" @keydown.esc="onKeyUpEsc" @blur="onBlur" @input="update" :autofocus="typeof preventAutofocus !== 'undefined' && !preventAutofocus ? false : true">
        <ul v-show="hasItems">
          <li v-for="(item, $item) in items" :key="item.uuid" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
            <span v-text="item.name"></span>
          </li>
        </ul>
        <!-- <ul>
          <li>
            <span>test</span>
          </li>
          <li>
            <span>test</span>
          </li>
        </ul> -->
    </div>
    <font-awesome-icon v-show="myValue.value !== null" icon="times-circle" class="text-secondary remove-custome fa-1x" @click="resetTypeahead"></font-awesome-icon>
    <input v-show="myValue.value !== null" type="text" class="form-control typeahead-value" v-model="myValue.label" readonly>
    </div>
</template>

<script>
import VueTypeahead from 'vue-typeahead'

export default {
  props: ['model', 'item', 'urlSearch', 'placeholder', 'labelFields', 'arrResponse', 'customQueryParamName', 'preventAutofocus', 'type'],
  extends: VueTypeahead,
  data () {
    return {
      isHide: false,
      myValue: {
        value: null,
        label: null,
        quantity: null
      },
      src: this.urlSearch,
      data: {},
      limit: 100,
      minChars: 3,
      selectFirst: false,
      queryParamName: 'q'
    }
  },
  beforeMount () {
    if (typeof this.customQueryParamName !== 'undefined') {
      this.queryParamName = this.customQueryParamName
    }
  },
  watch: {
    urlSearch: function (val) {
      this.src = val
    }
  },
  methods: {
    onBlur () {
      this.reset()
      this.$emit('onblur')
      this.isHide = false
    },
    onKeyUpEsc () {
      this.reset()
      this.$emit('onkeyupesc')
    },
    onHit (item) {
      if (typeof item !== 'undefined') {
        this.myValue.value = item.uuid
        this.myValue.label = item.name
        this.myValue.quantity = item.quantity
        this.model.value = item.uuid
        this.model.label = typeof item.name !== 'undefined' ? item.name : '-'
        this.model.quantity = item.quantity
        this.afterHit()
      } else {
        this.afterHit(this.query)
        this.isHide = false
      }
    },
    resetTypeahead () {
      this.myValue.value = null
      this.myValue.label = null
      this.myValue.quantity = null
      this.model.value = null
      this.model.label = null
      this.model.quantity = null
      this.afterHit()
    },
    prepareResponseData (data) {
      this.isHide = data.length === 0
      let resp = []
      data = this.arrResponse === null ? data : data._embedded[this.arrResponse]
      data.forEach((d) => {
        let r = {
          uuid: d.uuid,
          name: '',
          quantity: d.quantity
        }
        this.labelFields.forEach((label, quantity, i) => {
          r.name += (i ? ' ' : '') + (d[label] !== null ? d[label] : '')
        })
        resp.push(r)
      })
      return resp
    },
    afterHit () {
      this.$emit('afterHit')
    }
  }
}
</script>
<style scoped>
  ul {
    list-style-type: none;
    background-color: #f8f8f8;
    padding-left: 0;
    box-shadow: 0px 5px 8px -6px #ccc;
    z-index: 9999999 !important;
    position: absolute;
    width: 91%;
    /* padding-top: 5px;
    padding-bottom: 5px; */
    padding-left: 0;
    box-shadow: 0px 5px 8px -6px #ccc;
  }
  li {
    cursor: pointer;
    font-size: 14px !important;
    padding-bottom: 7px;
    padding-bottom: 7px;
    padding-left: 10px;
  }
  li:hover {
    background-color: #7b7b7b14; 
  }
</style>
<style lang="sass" scoped>
  .remove-custome
    position: absolute;
    right: 24px;
    top: 32%;
    cursor: pointer;
    font-size: 12px;
  .spinner-border
    position: absolute;
    right: 22px;
    top: 25%;
  .input-typeahead
    .typeahead-group
      position: relative
    .fa-spin
      right: 15px
      padding: 15px 15px
      position: absolute
    .reset
      top: 14px
      right: 8px
      cursor: pointer
      position: absolute
      color: #888
      font-size: 13px
      text-align: center
      font-style: normal
    ul
      z-index: 99999999
      list-style-type: none
      padding: 0
      color: #fff
      background: #fff !important
      position: absolute
      min-width: 200px
      li
        padding: 10px
        border-bottom: 1px solid rgba(0, 0, 0, 0.06)
        &.active
          background: #000
          color: #fff
</style>
